/*
 * File: c:\Users\l.haddad\Desktop\MOBYBUY\mobybuy_backoffice\src\Utils\Response.utils.ts
 * Project: c:\Users\l.haddad\Desktop\MOBYBUY\mobybuy_backoffice
 * Created Date: Thursday June 19th 2025
 * Author: Tommy Boisseau
 * -----
 * Last Modified: Thursday June 19th 2025 11:47:52 am
 * Modified By: the developer formerly known as Tommy Boisseau at <t.boisseau@autobuy.fr>
 * -----
 * Copyright (c) 2025 Autobuy SAS
 * -----
 */

import { Dispatch, SetStateAction } from "react";

export const handleLine = (setLines: Dispatch<SetStateAction<{ key: string, value: string }[]>>) => (line: string) => {
    const trimmed = line.trim();
    if (!trimmed) return;

    const index = trimmed.indexOf(":");
    if (index === -1) return;

    const key = trimmed.slice(0, index).trim();
    const value = trimmed.slice(index + 1).trim();

    setLines((oldLines: { key: string, value: string}[]) => {
      const existingIndex = oldLines.findIndex(l => l.key === key);

      if (existingIndex === -1) {
        return [...oldLines, { key, value }];
      } else {
        const newLines = [...oldLines];
        newLines[existingIndex] = { key, value };
        return newLines;
      }
    });
};
